﻿import {translation} from "@2d-front-monorepo/core";
import {PaymentResult} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {formatCurrency} from "../../../functions";

export function FooterComponent({payment}: { payment: PaymentResult | null | undefined }): JSX.Element | undefined {
	const total = payment?.billing?.step?.total;
	if (total == null || total === 0) {
		return undefined;
	}

	return <div className="card">
		<footer className="layout horizontal">
			<span className="flex">{translation(PermitTranslations.price)}</span>
			<span>{formatCurrency(total)}</span>
		</footer>
	</div>;
}
